import { useNavigate, useLocation } from 'react-router-dom';
import updateParams from '../../../../../utils/updateParams';
import SharedButton from '../../../../../global/Button/Button';
import { SourceButtonGroupProps } from '../../../../../types';

const getRenderedSourceValue = (source: string) => source.replace('_', ' ');

const specialFilters = ['CURATED', 'CLINICALTRIALS', 'INFERRED', 'MODELS', 'TEXTMINING_HUMAN', 'ALL'];

function getCurrentSource(search: string): string | null {
  const params = new URLSearchParams(search);
  return params.get('source');
}

export default function SourceButtonGroup({ sourceList }: SourceButtonGroupProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentSource = getCurrentSource(location.search);

  const handleClick = (value: string) => {
    navigate({
      pathname: location.pathname,
      search: updateParams({ source: value }),
    });
  };

  return (
    <div className="flex flex-wrap gap-2" id="SUBMENU">
      {sourceList.map((value) => (
        <SharedButton
          key={value}
          onClick={() => handleClick(value)}
          isActive={currentSource === value}
          size="sm"
          className='text-blue'
          variant={specialFilters.includes(value) ? 'primary' : 'secondary'}
        >
          {getRenderedSourceValue(value)}
        </SharedButton>
      ))}
    </div>
  );
}
